<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16oMuL/images/9780765318756.jpg?1726444397948" alt="This image is the cover for the book Cold Choices"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cold Choices
      </h1>
      <p class="bookDescription body article font2">
        <p>Following the events Jerry Mitchell encountered in <i>Dangerous Ground</i>, the pilot-turned-submarine officer is now a department head, the navigator, aboard USS <i>Seawolf</i>. Now on a mission deep in the Barents Sea, north of Russia, <i>Seawolf</i> explores the sea floor, part of a sophisticated reconnaissance plan that will watch the Russian navy as it trains for battle. Although well outside Russia's territorial waters, <i>Seawolf</i> is ambushed by Russia's newest submarine, <i>Severodvinsk</i>. Although it doesn't fire any weapons, its aggressive new captain, Alexi Petrov, harasses the intruder with dangerously fast, insanely close passes by the American boat.<br/><br/>The two subs collide, with the Russian boat crippled and trapped on the bottom. Only <i>Seawolf</i> knows where she is, and the rest of the Russian fleet is too angry to listen. Mitchell and his shipmates have to keep their own damaged boat afloat, figure out a way to make the Russians listen, and keep the trapped Russian submariners alive until they can be saved - if that is even possible.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry Bond
      </h2>
      
      <p class="authorDescription body article"><P>LARRY BOND is the author of numerous <I>New York Times </I>bestselling thrillers, including <I>Vortex, Cauldron</I>, and <I>The Enemy Within.</I> A former Naval Intelligence officer, warfare analyst, and anti-submarine technology expert, he makes his home in Springfield, Virginia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?276c9934